import React from 'react';

export const CheckLogo = ({ fill = 'var(--check-color)' }) => {
  return (
    <svg width="12" height="36" viewBox="0 0 12 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 14.5625L4.125 21.4375L1 18.3125"
        stroke={fill}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
